import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bb29755"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-group" }
const _hoisted_2 = {
  key: 0,
  class: "input-group__input-address"
}

import { computed } from 'vue';
import { useOfferCardsStore } from '@/store/modules/offerCards';
import { useAppStore } from '@/store/modules/app';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputGroup',
  props: {
    height: { default: '36' }
  },
  setup(__props: any) {

const props = __props;

const inputs = computed(() => {
  return useOfferCardsStore().mainInputsParams;
});

const router = useRouter();
const changeAddressValue = (point: [string, string]) => {
  useOfferCardsStore().updateCenterPointMap(point[1], point[0]);
  if (useAppStore().getWindowWidth() <= 600) {
    router.push({ name: 'fullMap' });
  }

  useOfferCardsStore().showResultBlock(true);
  if (!useOfferCardsStore().offerCards.length) {
    useOfferCardsStore().showResultBlock();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_base_address_input = _resolveComponent("base-address-input")!
  const _component_base_select_input = _resolveComponent("base-select-input")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_divider = _resolveComponent("base-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inputs.value, (input, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: input.id,
        style: _normalizeStyle({ gridArea: `input${i + 1}` }),
        class: "input-group__input"
      }, [
        (input.id === 6)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_base_address_input, {
                modelValue: input.value,
                "onUpdate:modelValue": ($event: any) => ((input.value) = $event),
                height: _ctx.height,
                label: input.label,
                styles: { border: 'none' },
                type: input.type,
                filled: "",
                hideArrows: "",
                onChangeLocation: _cache[0] || (_cache[0] = ($event: any) => (changeAddressValue($event)))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "height", "label", "type"])
            ]))
          : (input.type === 'select')
            ? (_openBlock(), _createBlock(_component_base_select_input, {
                key: 1,
                height: _ctx.height,
                label: input.label,
                modelValue: input.value,
                options: input.options,
                styles: { border: 'none' },
                clearable: "",
                filled: "",
                "onUpdate:modelValue": ($event: any) => {
          _unref(useOfferCardsStore)().updateMainInputsParams({ id: input.id, value: $event });
          _unref(useOfferCardsStore)().showResultBlock();
        }
              }, null, 8, ["height", "label", "modelValue", "options", "onUpdate:modelValue"]))
            : (_openBlock(), _createBlock(_component_base_input, {
                key: 2,
                modelValue: input.value,
                "onUpdate:modelValue": ($event: any) => ((input.value) = $event),
                height: _ctx.height,
                label: input.label,
                max: input.max,
                min: input.min,
                styles: { border: 'none' },
                type: input.type,
                filled: "",
                hideArrows: "",
                onBlur: _cache[1] || (_cache[1] = ($event: any) => (_unref(useOfferCardsStore)().showResultBlock()))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "height", "label", "max", "min", "type"]))
      ], 4))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inputs.value?.length, (i) => {
      return (_openBlock(), _createElementBlock("div", {
        style: _normalizeStyle({ gridArea: `verticalDivider${i}` }),
        class: "input-group-verticalDivider center"
      }, [
        _createVNode(_component_base_divider, {
          inset: "80%",
          vertical: ""
        })
      ], 4))
    }), 256)),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
      return _createVNode(_component_base_divider, {
        style: _normalizeStyle({ gridArea: `horizontalDivider${i}` }),
        class: "input-group-horizontalDivider"
      }, null, 8, ["style"])
    }), 64))
  ]))
}
}

})